import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

const { onRequest, onSuccess, onFailure } = rootActions.templates.staticEnums
function* staticEnumsSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/notifications/templates/static-enums`)
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload.sagaCB) {
                yield payload.sagaCB?.onSuccess(response.result)
            }
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* staticEnumsSaga(): any {
    yield takeLatest(onRequest, staticEnumsSagaTask)
}

export default staticEnumsSaga
